import b from 'b_';
import { SimpleCallback, Text } from 'platform-components/common';
import React, { ReactElement } from 'react';

import { CalendarPlanShowcaseTitle } from '../__title/calendar-plan-showcase__title';

import './calendar-plan-showcase__header.scss';

interface Props {
    button: ReactElement;
    description?: string;
    isOpened: boolean;
    subtitle: string;
    handleUploadButtonClick: SimpleCallback;
}

export const CalendarPlanShowcaseHeader = React.memo(({ subtitle, button, description }: Props) => {
    const Description = () =>
        description ? (
            <>
                <div className={b('library-calendar-plan-showcase', 'header-separator')} />
                <div className={b('library-calendar-plan-showcase', 'header-description')}>
                    <Text size={Text.SIZE.S}>{description}</Text>
                </div>
            </>
        ) : null;

    return (
        <div className={b('library-calendar-plan-showcase', 'header')}>
            <div className={b('library-calendar-plan-showcase', 'header-wrapper')}>
                <div className={b('library-calendar-plan-showcase', 'header-main-content')}>
                    {button}
                    <div className={b('library-calendar-plan-showcase', 'header-titles')}>
                        <div className={b('library-calendar-plan-showcase', 'header-subtitle')}>
                            <Text size={Text.SIZE.S} weight={Text.WEIGHT.M}>
                                {subtitle}
                            </Text>
                        </div>
                        <CalendarPlanShowcaseTitle />
                    </div>
                </div>
                <Description />
            </div>
        </div>
    );
});
